import { ISelectOption } from 'interfaces';

const processFoundOption = <T>(
  value: T,
  acc: ISelectOption<T> | null,
  curr: ISelectOption<T>
): ISelectOption<T> | null => {
  if (curr.value === value) {
    return curr;
  }

  if (curr.children) {
    return curr.children.reduce(
      (acc, curr) => processFoundOption(value, acc, curr),
      acc
    );
  }

  return acc;
};

export const findOptionByValue = <T>(
  value: T,
  options: ISelectOption<T>[]
): ISelectOption<T> | null =>
  options.reduce(
    (acc, curr) => processFoundOption<T>(value, acc, curr),
    null as ISelectOption<T> | null
  );

export const getOptionLabelByValue = <T>(
  value: T | T[],
  options: ISelectOption<T>[],
  unknownOptionPlaceholder = 'Неизвестная опция',
  placeholder = 'Не выбрано'
) =>
  Array.isArray(value)
    ? value.map(
        (v) => findOptionByValue(v, options)?.label ?? unknownOptionPlaceholder
      )
    : value || value === 0
    ? findOptionByValue(value, options)?.label ?? unknownOptionPlaceholder
    : placeholder;
